<template>
  <div class="radio">radio</div>
</template>

<script>
  export default {
    name: 'radio',
    data() {
      return {}
    },
    methods: {},
    computed: {},
    components: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/radio/radio.vue